<template>
  <div class="dacb-message" :class="{ '-local': !!message.attributes.customer_id }">
    <div
      v-if="!message.location"
      class="dacb-text"
      :style="{ 'background-color': backgroundColour, color: textColour }"
      v-html="messageContent"
    ></div>
    <div class="dacb-received" :title="message.attributes.created_at">{{senderName}} {{ fancyTime }}</div>
  </div>
</template>

<script>
import { formatDistance, parse } from "date-fns";
import { arSA, enGB } from "date-fns/locale";
import { marked } from "marked";
import { emojify } from "node-emoji";
import { mapState } from "vuex";

const locales = [enGB, arSA];

export default {
  name: "Message",

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      now: new Date().getTime(),
      intervalId: null
    };
  },

  computed: {
    ...mapState({
      options: (state) => state.options.options
    }),

    fancyTime() {
      let locale = locales[0];
      const getLocale = window.localStorage.getItem("i18nextLng");
      if (getLocale && getLocale.startsWith("ar")) {
        locale = locales[1];
      }
      return formatDistance(
        parse(this.message.attributes.created_at, "yyyy-MM-dd HH:mm:ss xxxx", new Date()),
        new Date(this.now),
        { locale }
      );
    },

    messageContent() {
      try {
        let str = marked.parse(this.message.attributes.content);

        // line breaks
        str = str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + "<br>" + "$2").trim();

        // don't let message end in a break
        if (str.substr(str.length - 4, str.length) === "<br>") {
          str = str.slice(0, -4);
        }

        // Open links in new tabs
        str = str.replace(/<a /gi, "<a target='_blank' ");

        // Emoji
        str = emojify(
          str,
          (name) => {
            return ":" + name + ":";
          },
          (code) => {
            return '<span class="emoji">' + code + "</span>";
          }
        );

        return str.trim();
      } catch (err) {
        console.error("Error parsing message:", err);
        return this.message.attributes.content;
      }
    },

    backgroundColour() {
      if (this.message.attributes.customer_id) {
        return this.options.primaryColour;
      } else {
        return "#FFFFFF";
      }
    },

    textColour() {
      if (this.message.attributes.customer_id) {
        return this.options.textColour;
      } else {
        return "#494949";
      }
    },

    senderName() {
      return this.message.attributes.customer_id ? 'You' : 'Ripley Agent';
    }

  },

  created() {
    this.intervalId = setInterval(() => {
      this.now = new Date().getTime();
    }, 10000);
  },

  unmounted() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>
